/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Базовая вью для затемнения экрана под попапом.
   * Используется на мобильной версии
   */
  app.FaderBaseView = app.View.extend({

    toggle: function () {
    },

    show: function () {
    },

    hide: function () {
    }
  });
})(jQuery);

}.call(window));